var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _vm.code ? _c('icon-pure-language', { attrs: { "language": { name: _vm.name, code: _vm.code }, "show-code": _vm.showCode, "resolver": _vm.resolver } }) : _c('span', { staticClass: "iconLanguage" }, [_vm._v(" " + _vm._s(_vm.name) + " ")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };